import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ApiService } from './api.service';
import { PlantWithSectorsHierarchy } from '../models/plant-with-sectors.model';

@Injectable({
  providedIn: 'root'
})
export class FunctionalLocationHierarchyService {

  constructor(private apiService: ApiService) {}
  
  public getFunctionalLocationHierarchy(): Observable<any> {
    return this.apiService.get<string>(`/FunctionalLocationHierarchy/GetFunctionalLocationHierarchy`);
  }
    
  public getFunctionalLocationHierarchyHash(): Observable<string> {
    return this.apiService.get<string>(`/FunctionalLocationHierarchy/GetFunctionalLocationHierarchyHash`, undefined, undefined, false, 'text');
  }

  public getPlantsWithMainWorkCenters(): Observable<PlantWithSectorsHierarchy> {
    return this.apiService.get<PlantWithSectorsHierarchy>(`/FunctionalLocationHierarchy/GetPlantsWithMainWorkCenters`);
  }

  public getPlantsWithMainWorkCentersHash(): Observable<string> {
    return this.apiService.get<string>(`/FunctionalLocationHierarchy/GetPlantsWithMainWorkCentersHash`, undefined, undefined, false, 'text');
  }
}
